import { SpaTreatmentVersion as SpaTreatment } from './SpaTreatmentVersion';

export default SpaTreatment;
